export default __webpack_public_path__ + "static/media/The_New_York_Times.fe235d4b.svg";